import vertImageOne from '../images/real-eastate-dominican-republic-2.jpeg'
import vertImageTwo from '../images/real-eastate-dominican-republic-3.jpeg'
import vertImageThree from '../images/real-eastate-lagos-2.jpeg'
import vertImageFour from '../images/real-eastate-lagos-3.jpeg'


export const InfoData = {
  heading: 'Ultra Luxury',
  paragraphOne: `Spend the day in the circular deck, relax by the pool, watch your children play in the gardens, and relax in the evening in the main salon or private den; sensations of Infinity are everywhere. There is no other property in all Casa de Campo available today which combines exceptional quality, meticulous details, captivating views and all the contemporary magnificence of Villa High-Class.`,
  paragraphTwo: 'Flanked on all sides by palm trees and endless vistas of blues, whites and greens, Villa High-Class is situated on a unique 4,798 SM / 51,647 SF home site within an impressive 1,433 SM / 15,400 SF of top-quality construction including outdoor areas',
  buttonLabel: 'View homes',
  image: vertImageOne,
  reverse: false,
  delay: 100
}

export const InfoDataTwo = {
  heading: 'In Casa De Campo',
  paragraphOne: 'Extremely private with unobstructed, panoramic views of the Caribbean Sea, six (6) uninterrupted ocean view spacious bedrooms with impeccable decor, three of which are Master suites, an elevator, state of the art kitchen, tropical, lush landscaping, two pools – one infinity pool with a jacuzzi overlooking the ocean and the other one is a plunge pool sitting on the rooftop deck, and plenty more spectacular amenities.',
  paragraphTwo: 'One visit and you will understand why this home is considered by many to be one of the most privileged homes and locations in all of Casa de Campo.',
  image: vertImageTwo,
  reverse: true,
  delay: 300
}

export const InfoDataThree = {
  heading: 'Lux Mare Casa L',
  paragraphOne: '“An amazing place, with luxurious facilities! A complete concept, with beautiful villas and stunning scenery.” – Kristine, Google Reviews',
  image: vertImageThree,
  reverse: true,
  delay: 300
}

export const InfoDataFour = {
  heading: 'High End Interior',
  paragraphOne: '“Fantastic beautiful villa with an architecture that meets both physical and spiritual needs! Must only be experienced! Incredibly nice people in the team around LUX MARE, nothing is missing here! Value for money. Going back more than happy.” – Lisa, Direct Review',
  image: vertImageFour,
  reverse: true,
  delay: 300
}

export default InfoData


// https://360luxuryrealestate.com/listings/villa-high-class-is-a-vacation-rental-home-without-limits/ 
// https://hauteretreats.com/thailand-villa-rentals/
// https://www.airbnb.com/indonesia/stays/luxury
// https://www.google.com/search?q=luxury+villas+in+indonesia&tbm=isch&ved=2ahUKEwiFxZ-fx7KCAxWdMWIAHV_mDtMQ2-cCegQIABAA&oq=luxury+villas+in+indo&gs_lcp=CgNpbWcQARgBMgUIABCABDIHCAAQGBCABDoECCMQJzoGCAAQCBAeOgYIABAFEB5QhZYXWNKbF2CwthdoAXAAeACAAWeIAaQEkgEDNS4xmAEAoAEBqgELZ3dzLXdpei1pbWfAAQE&sclient=img&ei=GIdKZYXZJ53jiLMP38y7mA0&bih=673&biw=1440&rlz=1C5CHFA_enUS997US997#imgrc=2_OWlHc-aKJT-M
// https://luxmare.pt/casa-l-luxury-villa-lagos-algarve/